var _excluded = ["secondarySelectedDate", "onSelect", "selectedDate", "excludeHolidays", "maxDate", "minDate", "weekDays", "isDisabled", "size", "showToday", "legendItems", "isMobileDatePicker", "yearsRange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { forwardRef, useEffect, useState } from 'react';
import { Group } from '../../../containers';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { Box } from '../Box';
import { CalendarContext } from './CalendarContext';
import { CalendarLegend, Header, Month, YearSelection } from './components';
import { useCalendar } from './hooks';
/**
 * @private For internal use only.
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var _BaseCalendar = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
    secondarySelectedDate,
    onSelect,
    selectedDate,
    excludeHolidays,
    maxDate,
    minDate,
    weekDays,
    isDisabled,
    size,
    showToday,
    legendItems,
    isMobileDatePicker,
    yearsRange
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    activeMonth,
    weeks,
    goToNextMonth,
    goToPreviousMonth,
    hasNextMonth,
    nextMonthLabels,
    hasPreviousMonth,
    previousMonthLabels,
    showYearSelection,
    setShowYearSelection,
    setSelectedYear,
    focusableDate,
    years,
    getClosestDateToFocus,
    setFocusedDate,
    focusedDate
  } = useCalendar({
    secondarySelectedDate,
    onSelect,
    selectedDate,
    excludeHolidays,
    maxDate,
    minDate,
    weekDays,
    yearsRange
  });
  var styles = useMultiStyleConfig('_BaseCalendar', {
    isMobileDatePicker,
    size
  }); // Used to detect if the year selection trigger button should be focused when the year selection is closed.

  var [shouldFocusYearSelectionTrigger, setShouldFocusYearSelectionTrigger] = useState(false);

  var _openYearSelection = () => {
    setShowYearSelection(true);
  };

  var closeYearSelection = date => {
    if (date) {
      setSelectedYear(date);
    }

    setShowYearSelection(false);
    setShouldFocusYearSelectionTrigger(true);
  }; // This is use to reset the state of the year selection button focus.


  useEffect(() => {
    if (shouldFocusYearSelectionTrigger) {
      setShouldFocusYearSelectionTrigger(false);
    }
  }, [shouldFocusYearSelectionTrigger]);
  return /*#__PURE__*/_jsx(CalendarContext.Provider, {
    value: {
      showToday,
      weeks,
      isDisabled,
      size,
      isMobileDatePicker,
      years,
      showYearSelection,
      focusableDate,
      focusedDate,
      weekDays
    },
    children: activeMonth && /*#__PURE__*/_jsxs(Group, _objectSpread(_objectSpread({
      variant: "vertical",
      spacing: "s",
      ref: ref,
      "data-component": "_BaseCalendar",
      "data-testid": "calendar-component"
    }, props), {}, {
      children: [/*#__PURE__*/_jsxs(Box, {
        "data-disabled": isDisabled || void 0,
        __css: styles['container'],
        children: [/*#__PURE__*/_jsx(Header, {
          activeMonth: activeMonth,
          hasPreviousMonth: hasPreviousMonth,
          hasNextMonth: hasNextMonth,
          nextMonthLabels: nextMonthLabels,
          previousMonthLabels: previousMonthLabels,
          goToPreviousMonth: goToPreviousMonth,
          goToNextMonth: goToNextMonth,
          openYearSelection: () => _openYearSelection(),
          shouldFocusYearSelectionTrigger: shouldFocusYearSelectionTrigger
        }), showYearSelection && /*#__PURE__*/_jsx(YearSelection, {
          activeMonth: activeMonth,
          closeYearSelection: closeYearSelection
        }), /*#__PURE__*/_jsx(Month, {
          onChangeFocusedDate: setFocusedDate,
          getClosestDateToFocus: getClosestDateToFocus
        })]
      }), legendItems !== null && legendItems !== void 0 && legendItems.length ? /*#__PURE__*/_jsx(Group, {
        variant: "horizontal",
        spacing: "s",
        children: legendItems.map((item, index) => {
          var _item$testId;

          return /*#__PURE__*/_jsx(CalendarLegend, {
            "data-testid": (_item$testId = item.testId) !== null && _item$testId !== void 0 ? _item$testId : "legend-item-".concat(index),
            label: item.label,
            date: item.date,
            variant: item.variant
          }, "legend-".concat(item.label));
        })
      }) : null]
    }))
  });
});
_BaseCalendar.displayName = '_BaseCalendar';
//# sourceMappingURL=_BaseCalendar.js.map